module.exports = "https://and-static.ghzs.com/web/bbs-mobile/static/img/icon_rili.8ad14.png";